import { RichError } from '#/utils/RichError';
import { setLatestAppVersion } from '#/zustand-stores/appVersionStore';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';

export function parseJsonResponse(
  xhr: XMLHttpRequest,
  reject: (error: Error) => void,
) {
  if (!xhr.responseText) {
    return null;
  }

  const contentType = xhr.getResponseHeader('Content-Type');
  if (contentType && !contentType.includes('json')) {
    reject(
      new RichError('Invalid Content-Type for JSON response', {
        responseURL: xhr.responseURL,
        contentType,
      }),
    );
  }

  try {
    const json = JSON.parse(xhr.responseText);

    if (!HORIZON_ENABLED) {
      // eslint-disable-next-line no-underscore-dangle
      setLatestAppVersion(json._version);
    }

    return json;
  } catch (err) {
    reject(
      new RichError('Error parsing JSON response', {
        responseURL: xhr.responseURL,
        errorMessage: (err as Error).message,
      }),
    );
  }
}
